import { bufferWhen, concatAll } from "rxjs/operators";
export function holdWhen(releaseSelector) {
    return (source) => source.pipe(bufferWhen(releaseSelector), concatAll());
}
//# sourceMappingURL=holdWhen.js.map